import {
    Card,
    CardBody,
    CardFooter,
    Col,
    Container,
    Form,
    FormGroup,
    Input,
    Label,
    Row
} from 'reactstrap';
import Profile from './Profile/Profile';
import MarkProfile from './MarkProfile/MarkProfile';
import Profile2 from './Profile2/Profile2';
import ProfileDetails from './ProfileDetails/ProfileDetails';
import DetailImage from './DetailImage/DetailImage';
import Breadcrumbs from '../../../../CommonElements/Breadcrumbs/Breadcrumbs';
import {
    AboutMe,
    Address,
    Bio,
    EmailAddress,
    FirstName,
    Gender,
    LastName,
    Password,
    PostalCode,
    Users,
    UsersProfile,
    Website
} from '../../../../utils/Constant';
import CardHeaderCommon from '../../../../CommonElements/CardHeaderCommon/CardHeaderCommon';
import { dynamicImage } from '../../../../Service';
import { Btn, H3, H6 } from '../../../../AbstractElements';
import DataTable from 'react-data-table-component';
import { useEffect, useState } from 'react';
import { usersApi } from '../../../../Api';
import { User } from '../../../../Types/Users';
import { productListTableDataColumn } from '../../../../Data/Application/Ecommerce/ProductList';

const UsersProfileContainer = () => {
    const [userDetail, setUserDetail] = useState<User>({
        first_name: '',
        last_name: '',
        email: '',
        password: '',
        gender: 'male'
    });
    const [loadingUserDetail, setLoadingUserDetail] = useState(false);
    const handleSetUserDetail = (e: any) => {
        setUserDetail({ ...userDetail, ...e });
    };

    const getDetail = () => {
        usersApi
            .getProfile()
            .then((res: any) => {              
                setUserDetail(res.data.data);
                setLoadingUserDetail(false);
            })
            .catch((err) => {
                console.error(err);
            });
    };

    // const createUser = () => {
    //     usersApi
    //         .create(userDetail)
    //         .then((res) => {
    //             switch (user_type_id) {
    //                 case '2':
    //                     navigate(`/suppliers`);
    //                     break;
    //                 case '3':
    //                     navigate(`/customers`);
    //                     break;

    //                 default:
    //                     break;
    //             }
    //         })
    //         .catch((err) => {
    //             console.error(err);
    //         });
    // };

    // const updateUser = () => {
    //     setLoadingUserDetail(true);
    //     usersApi
    //         .update(Number(id), { ...userDetail, user_type_id: String(userDetail.user_type_id) })
    //         .then((res) => {
    //             setUserDetail(res.data);
    //             setLoadingUserDetail(false);
    //         })
    //         .catch((err) => {
    //             console.error(err);
    //         });
    // };

    // const formSubmit = () => {
    //     if (id) {
    //         updateUser();
    //     } else {
    //         createUser();
    //     }
    // };

    useEffect(() => {
        getDetail();
    }, []);
    return (
        <>
            <Breadcrumbs
                mainTitle={UsersProfile}
                parent={Users}
            />
            <Container fluid>
                <div className="user-profile">
                    <Row>
                        <Profile />
                        <Col xl="4">
                            <Card>
                                <CardHeaderCommon
                                    title={''}
                                    tagClass="card-title mb-0"
                                />
                                <CardBody>
                                    <Form>
                                        <FormGroup>
                                            <H6 className="form-label">{Bio}</H6>
                                            <textarea
                                                rows={5}
                                                className="form-control"
                                                value={userDetail.bio}
                                                onChange={(e) =>
                                                    handleSetUserDetail({ bio: e.target.value })
                                                }
                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label>{EmailAddress}</Label>
                                            <Input
                                                placeholder="your-email@domain.com"
                                                value={userDetail.email}
                                                onChange={(e) =>
                                                    handleSetUserDetail({ email: e.target.value })
                                                }
                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label>{Password}</Label>
                                            <Input
                                                type="password"
                                                value={userDetail.password}
                                                onChange={(e) =>
                                                    handleSetUserDetail({
                                                        password: e.target.value
                                                    })
                                                }
                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label>{Website}</Label>
                                            <Input
                                                placeholder="Your website Url"
                                                value={userDetail.website_url}
                                                onChange={(e) =>
                                                    handleSetUserDetail({
                                                        website_url: e.target.value
                                                    })
                                                }
                                            />
                                        </FormGroup>
                                    </Form>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col xl="8">
                            <Form>
                                <Card>
                                    <CardHeaderCommon
                                        title={''}
                                        tagClass={'card-title mb-0'}
                                    />
                                    <CardBody>
                                        <Row>
                                            <Col
                                                sm="6"
                                                md="6">
                                                <FormGroup>
                                                    <Label>{FirstName}</Label>
                                                    <Input
                                                        type="text"
                                                        placeholder="First Name"
                                                        value={userDetail.first_name}
                                                        onChange={(e) =>
                                                            handleSetUserDetail({
                                                                first_name: e.target.value
                                                            })
                                                        }
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col
                                                sm="6"
                                                md="6">
                                                <FormGroup>
                                                    <Label>{LastName}</Label>
                                                    <Input
                                                        type="text"
                                                        placeholder="Last Name"
                                                        value={userDetail.last_name}
                                                        onChange={(e) =>
                                                            handleSetUserDetail({
                                                                last_name: e.target.value
                                                            })
                                                        }
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col
                                                sm="6"
                                                md="4">
                                                <FormGroup>
                                                    <Label>Phone</Label>
                                                    <Input
                                                        type="number"
                                                        placeholder="Phone"
                                                        value={userDetail.mobileNo}
                                                        onChange={(e) =>
                                                            handleSetUserDetail({
                                                                mobileNo: e.target.value
                                                            })
                                                        }
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md="5">
                                                <FormGroup>
                                                    <Label>Company</Label>
                                                    <Input
                                                        type="text"
                                                        placeholder="Company"
                                                        value={userDetail.company}
                                                        onChange={(e) =>
                                                            handleSetUserDetail({
                                                                company: e.target.value
                                                            })
                                                        }
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col
                                                sm="6"
                                                md="3">
                                                <FormGroup>
                                                    <Label>Email address</Label>
                                                    <Input
                                                        type="text"
                                                        placeholder="Position"
                                                        value={userDetail.email}
                                                        onChange={(e) =>
                                                            handleSetUserDetail({
                                                                email: e.target.value
                                                            })
                                                        }
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md="12">
                                                <FormGroup>
                                                    <Label>{Address}</Label>
                                                    <Input
                                                        type="text"
                                                        placeholder="Home Address"
                                                        value={userDetail.address}
                                                        onChange={(e) =>
                                                            handleSetUserDetail({
                                                                address: e.target.value
                                                            })
                                                        }
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col
                                                sm="6"
                                                md="4">
                                                <FormGroup>
                                                    <Label>City</Label>
                                                    <Input
                                                        type="text"
                                                        placeholder="City"
                                                        value={userDetail.city}
                                                        onChange={(e) =>
                                                            handleSetUserDetail({
                                                                city: e.target.value
                                                            })
                                                        }
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col
                                                sm="6"
                                                md="3">
                                                <FormGroup>
                                                    <Label>{PostalCode}</Label>
                                                    <Input
                                                        type="number"
                                                        placeholder="ZIP Code"
                                                        value={userDetail.postal_code}
                                                        onChange={(e) =>
                                                            handleSetUserDetail({
                                                                postal_code: e.target.value
                                                            })
                                                        }
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md="5">
                                                <FormGroup>
                                                    <Label>{Gender}</Label>
                                                    <Input
                                                        type="select"
                                                        className="btn-square form-select"
                                                        value={userDetail.gender}
                                                        onChange={(e) =>
                                                            handleSetUserDetail({
                                                                gender: e.target.value
                                                            })
                                                        }>
                                                        <option value={'male'}>{'Male'}</option>
                                                        <option value={'female'}>{'Female'}</option>
                                                    </Input>
                                                </FormGroup>
                                            </Col>
                                            <Col md="12">
                                                <Label>{AboutMe}</Label>
                                                <textarea
                                                    className="form-control"
                                                    rows={3}
                                                    placeholder="Enter About your description"
                                                    value={userDetail.about_me}
                                                    onChange={(e) =>
                                                        handleSetUserDetail({
                                                            about_me: e.target.value
                                                        })
                                                    }
                                                />
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Form>
                        </Col>
                        {userDetail.user_type_id === '2' && userDetail.products && (
                            <Col md="12">
                                <Card className="custom-project-card">
                                    <DataTable
                                        data={userDetail.products}
                                        columns={productListTableDataColumn}
                                        progressPending={loadingUserDetail}
                                        striped
                                        highlightOnHover
                                        pagination={false}
                                    />
                                </Card>
                            </Col>
                        )}
                    </Row>
                </div>
            </Container>
        </>
    );
};

export default UsersProfileContainer;
